<template>
    <div
        class="flex flex-col gap-8 w-100"
        data-test="event-calendar-list"
    >
        <EventCalendarFilter
            v-model:from="validFrom"
            v-model:to="validTo"
        />
        <SharedScrollableList
            :items="items"
            :is-scrollable="isScrollable"
            :is-scrolling="isLoading"
            class="flex flex-col gap-7"
            key-prop="id"
            :skeleton-count="SKELETON_COUNT"
            @scroll="onScroll"
        >
            <template #item="{ item }">
                <TimelineItem
                    :item="item"
                    class="bg-white w-full rounded-md px-6 py-5"
                />
            </template>
            <template #skeleton>
                <TimelineContentLoader />
            </template>
            <template #empty>
                <SharedInfoMessage>
                    {{ $t('eventCalendar.no_events_in_period') }}
                </SharedInfoMessage>
            </template>
        </SharedScrollableList>
    </div>
</template>

<script async setup lang="ts">
    import { useEventCalendarList } from '~/composables/eventCalendarList';
    import EventCalendarFilter from '~/components/eventCalendar/EventCalendarFilter.vue';
    import SharedScrollableList from '~/components/shared/SharedScrollableList.vue';
    import TimelineItem from '~/components/timeline/TimelineItem.vue';
    import TimelineContentLoader from '~/components/timeline/TimelineContentLoader.vue';
    import SharedInfoMessage from '~/components/shared/SharedInfoMessage.vue';

    const SKELETON_COUNT = 3;

    const {
        items,
        validFrom,
        validTo,
        isLoading,
        isScrollable,
        fetchEventCalendar,
        onScroll
    } = useEventCalendarList();

    await fetchEventCalendar();
</script>
